import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";

// import { ELSSkeleton } from "components/common/elsevier/Skeleton/Skeleton";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import styles from "./DefaultSkeleton.module.scss";
function DefaultSkeleton(props) {
  return /*#__PURE__*/React.createElement(ELSGrid, _extends({
    className: styles.default_skeleton,
    container: true,
    justifyContent: "center"
  }, props), "The Application is initializating ...");
}
export default DefaultSkeleton;